import { useQuery } from '@tanstack/react-query';
import type { IbhBearingMaterialsDescriptionParams } from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import { fetchMaterialsDescription } from './fetchMaterialsDescription';

export function useMaterialsDescription(params: IbhBearingMaterialsDescriptionParams) {
  const { data } = useQuery({
    queryKey: ['materialsDescription', params.materialCode, params.locale],
    queryFn: () => fetchMaterialsDescription(params),
    enabled: !!params.materialCode && !!params.locale,
  });
  return data;
}
